import { apolloClient } from "../../vue-apollo";
import {
    GET_PAGINACION_NOTICIAS,
    GET_NOTICIAS_CON_PAGINACION,
    GET_NOTICIA
} from "../../graphql/queries";
import {
    // DAR_LIKE_NOTICIA,
    // QUITAR_LIKE_NOTICIA,
    DAR_LIKE,
    QUITAR_LIKE,
    AGREGAR_COMENTARIO_EMPRESA,
    EDITAR_COMENTARIO_EMPRESA,
    ELIMINAR_COMENTARIO_EMPRESA,
    DAR_LIKE_COMENTARIO_EMPRESA,
    QUITAR_LIKE_COMENTARIO_EMPRESA,
    INSERT_VISTO_GENERAL
} from "../../graphql/mutations";

export default {
    namespaced: true,
    state: {
        paginadorNoticiasIntranet: [],
        noticiasPaginadas: [],
        noticia: {},
        editar: false,
        loading: true,
    },
    getters: {
    },
    mutations: {
        INSERT_VISTO_SINGLE(state, response) {
            state.noticia.confirm_visto = state.noticia.id_noticia == parseInt(response.noticia) ? state.noticia.confirm_visto++ : state.noticia.confirm_visto;
        },

        SET_PAGINADOR_NOTICIAS(state, paginacion) {
            state.paginadorNoticiasIntranet = paginacion;
            //state.loading = !state.loading;
        },

        SET_NOTICIAS_PAGINADAS(state, noticias) {
            state.noticiasPaginadas = noticias;
            state.noticiasPaginadas.forEach(function (noticia) {
                noticia.comentarios = noticia.comentarios_compartidos;
            });
            //state.loading = !state.loading;
        },

        SET_LIKE_NOTICIA(state, likenoticia) {
            // console.log('NOTICIA LIKES/QUITAR LIKES', likenoticia);
            // console.log('NOTICIA LIST', state.noticia);
            // console.log(likenoticia.action)
            if (likenoticia.action) {
                state.noticia.likes.push(likenoticia.response);
                state.noticia.confirm_like = likenoticia.response;
            } else {
                state.noticia.likes = state.noticia.likes.filter(x => x.id_like !== likenoticia.response.id_like);
                state.noticia.confirm_like = null;
            }

        },

        SET_LIKE_NOTICIA_COMENTARIO(state, likecomentario) {
            let comentario_index = state.noticia.comentarios.findIndex(comentario => comentario.id_comentario == likecomentario.id_comentario);
            //console.log("DATA LIKE: ", likecomentario.likes);
            if (comentario_index != undefined) {
                //console.log('Comentario Encontrado', state.noticia.comentarios[comentario_index]);
                state.noticia.comentarios[comentario_index].likes = likecomentario.likes;
            }
        },

        SET_NOTICIA(state, objeto) {
            state.noticia = objeto;
            state.noticia.comentarios = objeto.comentarios_compartidos;
            state.noticia.comentarios.forEach(function (comentario) {
                comentario.is_edit = false;
                comentario.respuestas_comentarios.forEach(function (respuesta) {
                    respuesta.is_edit = false;
                });

            });
        },

        SET_COMENTARIO_NOTICIA(state, comentario) {
            state.noticia.comentarios_compartidos.unshift(comentario);
        },

        SET_UPDATE_COMENTARIO_NOTICIA(state, upComentario) {
            let comentario_index = state.noticia.comentarios_compartidos.findIndex(comentario => comentario.id_comentario == upComentario.id_comentario);
            if (comentario_index != undefined) {
                if (state.noticia.comentarios_compartidos.length > 0) Object.assign(state.noticia.comentarios_compartidos[comentario_index], upComentario)
            }
        },

        DEL_COMENTARIO_NOTICIA(state, comentario) {
            let found_index = state.noticia.comentarios.findIndex(coment => coment.id_comentario == comentario.id_comentario);
            if (found_index != undefined) {
                state.noticia.comentarios.splice(found_index, 1);
            }
        },

        SET_COMENTARIO_DEL_COMENTARIO_NOTICIA(state, respuesta) {
            state.noticia.comentarios_compartidos
            let comentario_index = state.noticia.comentarios_compartidos.findIndex(comentario => comentario.id_comentario == respuesta.id_padre_comentario);
            if (comentario_index != undefined) {
                if (state.noticia.comentarios_compartidos.length > 0) state.noticia.comentarios_compartidos[comentario_index].respuestas_comentarios.unshift(respuesta)
            }
        },

        SET_UPDATE_COMENTARIO_DEL_COMENTARIO(state, respuesta) {
            respuesta.is_edit = false;
            state.noticia.comentarios.forEach(function (comentario) {
                comentario.respuestas_comentarios.forEach(function (respue) {
                    if (respue.id_comentario == respuesta.id_comentario) {
                        console.log("acá está", respue);
                    }
                });
                let comentario_index = comentario.respuestas_comentarios.findIndex(res => res.id_comentario == respuesta.id_comentario);
                if (comentario_index != undefined) {
                    if (comentario.respuestas_comentarios.length > 0) Object.assign(comentario.respuestas_comentarios[comentario_index], respuesta)
                }

            });
        },

        DEL_COMENTARIO_COMENTARIO_NOTICIA(state, respuesta) {
            state.noticia.comentarios.forEach(function (comentario) {
                let comentario_index = comentario.respuestas_comentarios.findIndex(res => res.id_comentario == respuesta.id_comentario);
                if (comentario_index != undefined) {
                    comentario.respuestas_comentarios.splice(comentario_index, 1);
                }

            });
        },



    },
    actions: {
        async getPaginacionNoticias({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_PAGINACION_NOTICIAS,
                variables: data_
            }
            try {
                await apolloClient.query(params).then(res => {
                    if (!res.loading) response = res.data.paginadorNoticiasIntranet;
                });
            }
            catch (e) {
                console.log("Falla error, getPaginacionNoticias ", e);
            }
            return new Promise((resolve) => {
                if (response != null) {
                    if (response.length == 0) {
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_PAGINADOR_NOTICIAS", response);
                    }
                }
                else {
                    resolve(false);
                }

            });


        },

        async getNoticiasPaginadas({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_NOTICIAS_CON_PAGINACION,
                variables: data_,
                fetchPolicy: 'network-only'
            }
            try {
                await apolloClient.query(params).then(res => {
                    console.log("respuest de server getNoticiasPaginadas: ", res.data.noticiasPaginadas);
                    if (!res.loading) response = res.data.noticiasPaginadas;
                });
            }
            catch (e) {
                console.log("Falla error, getNoticiasPaginadas ", e);
            }
            return new Promise((resolve) => {
                if (response != null) {
                    if (response.length == 0) {
                        resolve(false);
                        commit("SET_NOTICIAS_PAGINADAS", response);
                    }
                    else {
                        resolve(response);
                        commit("SET_NOTICIAS_PAGINADAS", response);
                    }
                }
                else {
                    resolve(false);
                    //commit("SET_NOTICIAS_PAGINADAS", response);
                }

            });


        },

        async getUnaNoticia({ commit }, data_) {
            let response = null;
            let params = {
                query: GET_NOTICIA,
                variables: data_
            }
            try {
                await apolloClient.query(params).then(res => {
                    if (!res.loading) response = res.data.noticia;
                });
            }
            catch (e) {
                console.log("Falla error, getUnaNoticia ", e);
            }
            return new Promise((resolve) => {
                if (response != null) {
                    if (response.length == 0) {
                        resolve(false);
                    }
                    else {
                        resolve(response);
                        commit("SET_NOTICIA", response);
                    }
                }
                else {
                    resolve(false);
                }

            });


        },

        async addLikeNoticia({ commit }, data_) {
            let response = null;
            let data = [];
            let params = {
                mutation: DAR_LIKE,
                variables: data_
            }
            try {
                await apolloClient.mutate(params).then(res => {
                    // console.log(res.data)
                    // console.log('SET_LIKE_NOTICIA', res.data.agregarLikesEmpresa);
                    if (!res.loading) data = res.data.agregarLikesEmpresa;
                    response = data;
                });
            }
            catch (e) {
                console.log("Falla metodo addLikeNoticia: ", e);
            }
            return new Promise((resolve) => {
                if (response != null) {
                    resolve(response);
                    let likeNoticia = {
                        response: response,
                        action: true
                    }
                    commit("SET_LIKE_NOTICIA", likeNoticia);
                }
                else {
                    resolve(false);
                }

            });
        },

        async addLikeComentarioEmpresa({ commit }, data_) {
            let response = null;
            let data = [];
            let params = {
                mutation: DAR_LIKE_COMENTARIO_EMPRESA,
                variables: data_
            }
            try {
                await apolloClient.mutate(params).then(res => {
                    console.log('SET_LIKE_NOTICIA_COMENTARIO', res.data.darLikeComentarioEmpresa);
                    if (!res.loading) data = res.data.darLikeComentarioEmpresa;
                    response = data;
                });
            }
            catch (e) {
                console.log("Falla metodo addLikeComentarioEmpresa: ", e);
            }
            return new Promise((resolve) => {
                if (response != null) {
                    resolve(response);
                    commit("SET_LIKE_NOTICIA_COMENTARIO", response);
                }
                else {
                    resolve(false);
                }

            });
        },

        async delLikeNoticia({ commit }, data_) {
            let response = null;
            let data = [];
            let params = {
                mutation: QUITAR_LIKE,
                variables: data_
            }
            try {
                await apolloClient.mutate(params).then(res => {
                    // console.log('SET_LIKE_NOTICIA', res.data.eliminarLikeEmpresa);
                    if (!res.loading) data = res.data.eliminarLikeEmpresa;
                    response = data;
                });
            }
            catch (e) {
                console.log("Falla metodo delLikeNoticia: ", e);
            }
            return new Promise((resolve) => {
                if (response != null) {
                    resolve(response);
                    let likeNoticia = {
                        response: response,
                        action: false
                    }
                    commit("SET_LIKE_NOTICIA", likeNoticia);
                }
                else {
                    resolve(false);
                }

            });
        },

        async delLikeComentarioEmpresa({ commit }, data_) {
            let response = null;
            let data = [];
            let params = {
                mutation: QUITAR_LIKE_COMENTARIO_EMPRESA,
                variables: data_
            }
            try {
                await apolloClient.mutate(params).then(res => {
                    console.log('SET_LIKE_NOTICIA_COMENTARIO', res.data.quitarLikeComentarioEmpresa);
                    if (!res.loading) data = res.data.quitarLikeComentarioEmpresa;
                    response = data;
                });
            }
            catch (e) {
                console.log("Falla metodo delLikeComentarioEmpresa: ", e);
            }
            return new Promise((resolve) => {
                if (response != null) {
                    resolve(response);
                    commit("SET_LIKE_NOTICIA_COMENTARIO", response);
                }
                else {
                    resolve(false);
                }

            });
        },

        async crearComentariosEmpresaNoticia({ commit }, data_) {
            let response = null;
            //let data = [];
            let params = {
                mutation: AGREGAR_COMENTARIO_EMPRESA,
                variables: data_
            }
            try {
                await apolloClient.mutate(params).then(res => {
                    //console.log('CREA SET_COMENTARIO_NOTICIA', res.data.agregarComentarioEmpresa);
                    if (!res.loading) response = res.data.agregarComentarioEmpresa;
                    //response = data;
                });
            }
            catch (e) {
                console.log("Falla metodo crearComentariosEmpresaNoticia: ", e);
            }
            return new Promise((resolve) => {
                if (response != null) {
                    resolve(response);
                    if (data_.id_comentario == "") {
                        console.log("comentario")
                        commit("SET_COMENTARIO_NOTICIA", response);
                    } else {
                        response.id_padre_comentario = data_.id_comentario;
                        commit("SET_COMENTARIO_DEL_COMENTARIO_NOTICIA", response);
                    }
                    //console.log("revisando que es comentario o comentario del comentario: ", data_.id_comentario);
                }
                else {
                    resolve(false);
                }

            });
        },

        async editarComentarioEmpresaNoticia({ commit }, data_) {
            let response = null;
            //let data = [];
            let params = {
                mutation: EDITAR_COMENTARIO_EMPRESA,
                variables: data_
            }
            try {
                await apolloClient.mutate(params).then(res => {
                    console.log('EDITAR SET_COMENTARIO_NOTICIA', res.data.editarComentarioEmpresa);
                    if (!res.loading) response = res.data.editarComentarioEmpresa;
                    //response = data;
                });
            }
            catch (e) {
                console.log("Falla metodo editarComentarioEmpresaNoticia: ", e);
            }
            return new Promise((resolve) => {
                if (response != null) {
                    resolve(response);
                    commit("SET_UPDATE_COMENTARIO_NOTICIA", response);
                }
                else {
                    resolve(false);
                }

            });
        },

        async editarComentarioDelComentarioEmpresaNoticia({ commit }, data_) {
            let response = null;
            //let data = [];
            let params = {
                mutation: EDITAR_COMENTARIO_EMPRESA,
                variables: data_
            }
            try {
                await apolloClient.mutate(params).then(res => {
                    console.log('EDITAR SET_UPDATE_COMENTARIO_DEL_COMENTARIO', res.data.editarComentarioEmpresa);
                    if (!res.loading) response = res.data.editarComentarioEmpresa;
                    //response = data;
                });
            }
            catch (e) {
                console.log("Falla metodo editarComentarioEmpresaNoticia: ", e);
            }
            return new Promise((resolve) => {
                if (response != null) {
                    resolve(response);
                    commit("SET_UPDATE_COMENTARIO_DEL_COMENTARIO", response);
                }
                else {
                    resolve(false);
                }

            });
        },

        async eliminarComentarioEmpresaNoticia({ commit }, data_) {
            console.log('data para el delete comentarios noticia');
            let response = null;
            let data = [];
            let params = {
                mutation: ELIMINAR_COMENTARIO_EMPRESA,
                variables: data_
            }
            try {
                await apolloClient.mutate(params).then(res => {
                    console.log('DEL_COMENTARIO_NOTICIA ELIMINAR', res.data.eliminarComentarioEmpresa);
                    if (!res.loading) data = res.data.eliminarComentarioEmpresa;
                    response = data;
                });
            }
            catch (e) {
                console.log("Error de delPostMuro post: ", e);
            }
            return new Promise((resolve) => {
                if (response != null) {
                    //console.log("ELIMINAR COMENTARIO DE POST ",response);
                    commit("DEL_COMENTARIO_NOTICIA", response);
                    resolve(response);
                }
                else {
                    resolve(false);
                }

            });
        },

        async eliminarComentarioDelComentario({ commit }, data_) {
            console.log('data para el delete comentarios noticia');
            let response = null;
            let data = [];
            let params = {
                mutation: ELIMINAR_COMENTARIO_EMPRESA,
                variables: data_
            }
            try {
                await apolloClient.mutate(params).then(res => {
                    console.log('DEL_COMENTARIO_COMENTARIO_NOTICIA ELIMINAR', res.data.eliminarComentarioEmpresa);
                    if (!res.loading) data = res.data.eliminarComentarioEmpresa;
                    response = data;
                });
            }
            catch (e) {
                console.log("Error de delPostMuro post: ", e);
            }
            return new Promise((resolve) => {
                if (response != null) {
                    //console.log("ELIMINAR COMENTARIO DE POST ",response);
                    commit("DEL_COMENTARIO_COMENTARIO_NOTICIA", response);
                    resolve(response);
                }
                else {
                    resolve(false);
                }

            });
        },
        //INSERTAR VISTO GENERAL
        async insertVistoSingle({ commit }, data_) {
            let response = null;
            let data = [];
            let params = {
                mutation: INSERT_VISTO_GENERAL,
                variables: data_
            }
            try {
                await apolloClient.mutate(params).then(res => {
                    console.log('INSERT VISTO', res.data);
                    if (!res.loading) data = res.data;
                    response = data;
                });
            }
            catch (e) {
                console.log("Falla metodo deleteNotificaciones: ", e);
            }
            return new Promise((resolve) => {
                if (response != null) {
                    commit("INSERT_VISTO_SINGLE", {
                        noticia: data_.id_objeto,
                        respuesta: response
                    });
                    resolve(response);
                }
                else {
                    resolve(false);
                }

            });
        },

    }
};